import { render, staticRenderFns } from "./verse.vue?vue&type=template&id=f1044180&scoped=true"
import script from "./verse.vue?vue&type=script&lang=js"
export * from "./verse.vue?vue&type=script&lang=js"
import style0 from "./verse.vue?vue&type=style&index=0&id=f1044180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1044180",
  null
  
)

export default component.exports